import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c679e89"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn date w15" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn ip w15" }, "IP"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn version w5" }, "App version"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn name w20" }, "Device name"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn model w20" }, "Device model"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn id w25" }, "Device id")
  ])
], -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "tabcolumn date w15" }
const _hoisted_5 = { class: "tabcolumn ip w15" }
const _hoisted_6 = { class: "tabcolumn version w5" }
const _hoisted_7 = { class: "tabcolumn name w20" }
const _hoisted_8 = { class: "tabcolumn model w20" }
const _hoisted_9 = { class: "tabcolumn id w25" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["id"]
const _hoisted_12 = { class: "tabcolumn date w15" }
const _hoisted_13 = { class: "tabcolumn ip w15" }
const _hoisted_14 = { class: "tabcolumn version w5" }
const _hoisted_15 = { class: "tabcolumn name w20" }
const _hoisted_16 = { class: "tabcolumn model w20" }
const _hoisted_17 = { class: "tabcolumn id w25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.UUID) + "/Logs", 1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoBack($event)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'arrow-left' ] })
        ])
      ])
    ]),
    (_ctx.apiError.length > 0)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "error",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.apiError.pop()))
        }, _toDisplayString(_ctx.apiError[_ctx.apiError.length-1]), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", null, [
      _hoisted_1,
      (_ctx.resultDevices.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultDevices, (element) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: element.uniqid,
                id: element.uniqid
              }, [
                _createElementVNode("td", _hoisted_4, _toDisplayString(element.datetime), 1),
                _createElementVNode("td", _hoisted_5, _toDisplayString(element.ip), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(element.app_version), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(element.device_name), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(element.device_model), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(element.device_uniqid), 1)
              ], 8, _hoisted_3))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (element) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: element.uniqid,
                id: element.uniqid
              }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(element.datetime), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(element.ip), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(element.app_version), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(element.device_name), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(element.device_model), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(element.device_uniqid), 1)
              ], 8, _hoisted_11))
            }), 128))
          ]))
    ])
  ]))
}